module.exports = __webpack_public_path__ + "img/nbo-visa.efc68b79.png";